import React, { useState } from 'react';
import { convertToRaw, EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const fontSizeOptions = [
  { label: 'Small', value: '12pt' },
  { label: 'Regular', value: '16pt' },
  { label: 'Large', value: '20pt' }
];

const sizeLabelMap = fontSizeOptions.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});

const CustomFontSizeDropdown = (props) => {
  const { config, onChange, expanded, onExpandEvent } = props;

  const [hoverOption, setHoverOption] = useState(null);

  return (
    <div className="rdw-fontsize-wrapper" aria-label="rdw-font-size-control">
      <div
        className="rdw-dropdown-wrapper rdw-fontsize-dropdown"
        aria-label="rdw-dropdown"
        aria-expanded={expanded}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="rdw-dropdown-selectedtext"
          title="Font Size"
          onClick={(e) => {
            e.preventDefault();
            onExpandEvent();
          }}>
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuOTIxIDMuMTE5YS40MjcuNDI3IDAgMCAwIC4zMzUuMTY0aC45N2EuNDI2LjQyNiAwIDAgMCAuMzA0LS4xMy40NDEuNDQxIDAgMCAwIC4xMjUtLjMxbC4wMDItMi40MWEuNDM0LjQzNCAwIDAgMC0uNDMtLjQzMkguNDNBLjQzNC40MzQgMCAwIDAgMCAuNDR2Mi40MDZjMCAuMjQyLjE5Mi40MzguNDMuNDM4aC45N2MuMTMgMCAuMjU0LS4wNi4zMzUtLjE2NWwuNzMtLjkzSDUuNTR2MTEuMzZjMCAuMjQxLjE5Mi40MzcuNDMuNDM3aDEuNzE3Yy4yMzcgMCAuNDMtLjE5Ni40My0uNDM3VjIuMTg4aDMuMDdsLjczNC45MzF6TTEzLjg5OCAxMS4yNjNhLjQyNS40MjUgMCAwIDAtLjQ4Mi0uMTQ2bC0uNTQ3LjE5NFY5LjYxN2EuNDQyLjQ0MiAwIDAgMC0uMTI2LS4zMS40MjYuNDI2IDAgMCAwLS4zMDQtLjEyN2gtLjQyOWEuNDM0LjQzNCAwIDAgMC0uNDMuNDM3djEuNjk0bC0uNTQ3LS4xOTRhLjQyNS40MjUgMCAwIDAtLjQ4MS4xNDYuNDQ0LjQ0NCAwIDAgMC0uMDE2LjUxMmwxLjMzMiAyLjAxN2EuNDI3LjQyNyAwIDAgMCAuNzEzIDBsMS4zMzMtMi4wMTdhLjQ0NC40NDQgMCAwIDAtLjAxNi0uNTEyeiIvPjwvZz48L3N2Zz4="
            alt=""
          />
          <div className="rdw-dropdown-carettoclose"></div>
        </a>
        {expanded && (
          <ul className="rdw-dropdown-optionwrapper">
            {config.options.map((option) => {
              const label = sizeLabelMap[option];
              return (
                <li
                  key={option}
                  className={`rdw-dropdownoption-default rdw-fontsize-option${
                    option === hoverOption ? ' rdw-dropdownoption-highlighted' : ''
                  }`}
                  onClick={() => onChange(option)}
                  onMouseEnter={() => setHoverOption(option)}
                  onMouseLeave={() => setHoverOption(null)}>
                  {label}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

const FormWYSWYG = ({ value, onChange, isError }) => {
  const [editorState, setEditorState] = useState(() => {
    const blocksFromHtml = htmlToDraft(value || '');
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
  });

  return (
    <Editor
      editorState={editorState}
      textAlignment="center"
      toolbarClassName=""
      wrapperClassName=""
      editorClassName={`form-control${isError ? ' is-invalid' : ''}`}
      onEditorStateChange={(editorState) => {
        setEditorState(editorState);
        onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
      }}
      toolbar={{
        options: ['inline', 'textAlign', 'link', 'fontSize'],
        inline: {
          options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript']
        },
        textAlign: { options: ['left', 'center', 'right'] },
        fontSize: {
          options: fontSizeOptions.map((option) => option.value),
          component: CustomFontSizeDropdown
        }
      }}
      stripPastedStyles={true}
      editorStyle={{
        fontSize: '16pt'
      }}
    />
  );
};

export default FormWYSWYG;
